// extracted by mini-css-extract-plugin
export default {"component":"styles__component--Uc0hN","contents":"styles__contents--Qp8qv"};